import { Routes } from "src/constants/api_url";

export const getPaymentReceiptUrl = async (filename) => {
  if (!filename) return "";
  const base = Routes.API_HOSTNAME;
  const newUrl = `${base}/uploaded_payment_receipt/${filename}`;
  try {
    const res = await fetch(newUrl, { method: "HEAD" });
    if (res.ok) return newUrl;
  } catch (e) {}
  return `${base}/payment_receipt/${filename}`;
};

export const getPaymentReceiptUrlSync = (filename) =>
  `${Routes.API_HOSTNAME}/uploaded_payment_receipt/${filename}`;
